import React, { useCallback, useEffect, useRef, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Home from "./pages/Home/Home";
// import Leaderboard from "./pages/Leaderboard/Leaderboard";
import Friends from "./pages/Friends/Friends";
import Earn from "./pages/Earn/Earn";
import Navbar from "./components/Navbar/Navbar";
import "./app.css";
import Airdrop from "./pages/Airdrop/Airdrop";
import GetStarted from "./components/GetStarted/GetStarted";
import ComingSoon from "./components/ComingSoon/ComingSoon";
import axios from "axios";
import DailySession from "./components/DailySession/DailySession";
import EarnPartner from "./pages/Earn/EarnPartner";
import Play from "./pages/Play/Play";
import DailyOpportunities from "./pages/Earn/DailyOpportunities";
import validateInfo from "./hooks/validateInfo";
import chestSound from "./assets/chestSound.mp3";
import dailySessionSound from "./assets/dailySessionSound.mp3";
import { toast, ToastContainer } from "react-toastify";
import getStartedWod from "./assets/getStartedWod.png";
import UnderMaintenance from "./components/UnderMaintenance";
import MainView from "./pages/NewLeaderboard/MainView";
import LeaderboardView from "./pages/NewLeaderboard/views/LeaderboardView";
import AirdropView from "./pages/NewLeaderboard/views/AirdropView";
import ProgressView from "./pages/NewLeaderboard/views/ProgressView";
import RankView from "./pages/NewLeaderboard/views/RankView";

const App = () => {
  const [showWelcome, setShowWelcome] = useState(true);
  const [airdrop, setAirdrop] = useState(false);
  const [isTelegram, setIsTelegram] = useState();
  const [username, setUsername] = useState("");
  const [chestReward, setChestReward] = useState(0);
  const [chestXp, setChestXp] = useState(0);
  const [userData, setUserData] = useState({
    tasks: [],
    completedTasks: [],
    totalPoints: 0,
    weeklyPoints: 0,
    streakPoints: 0,
    chestsPoints: 0,
    tasksPoints: 0,
    streakDay: 0,
    referralPoints: 0,
    lastStreakDate: undefined,
    chestTimeStamp: undefined,
    referredUsers: [],
    referralCode: "",
    walletAddress: null,
  });
  const [leaderboard, setLeaderboard] = useState({
    player: {},
    users: [],
    userCount: 0,
  });
  const [weeklyLeaderboard, setWeeklyLeaderboard] = useState({
    player: {},
    prevPlayer: {},
    weeklyUsers: [],
    prevWeeklyUsers: [],
  });
  const [jwt, setJwt] = useState();
  const [dailySession, setDailySession] = useState(true);
  const [loadingClaim, setLoadingClaim] = useState(false);
  const [canClaim, setCanClaim] = useState(false);
  const [loadingChest, setLoadingChest] = useState(false);
  const [canClaimHourly, setCanClaimHourly] = useState(false);
  const [error, setError] = useState("");
  const [loadingWallet, setLoadingWallet] = useState(false);
  const [connectPopup, setConnectPopup] = useState(false);
  const [changeWalletPopup, setChangeWalletPopup] = useState(false);
  const [generalLoading, setGeneralLoading] = useState(true);
  const [maintenance, setMaintenance] = useState(false);
  const chestSoundRef = useRef(null);
  const dailySessionSoundRef = useRef(null);
  const [hasTgTask, setHasTgTask] = useState(true);
  const [xpleaderboards, setXpLeaderboards] = useState({
    board1: [],
    board2: [],
    board3: [],
  });
  const [currentXp, setCurrentXp] = useState(0);

  const experienceRanks = [20000, 60000, 100100];

  function getRankInfo() {
    let rank = 1;
    let nextThreshold = experienceRanks[0];

    for (let i = 0; i < experienceRanks.length; i++) {
      if (currentXp > experienceRanks[i]) {
        rank = i + 2;
        nextThreshold = experienceRanks[i + 1] || null; // null if no more levels
      } else {
        break;
      }
    }

    const prevThreshold = rank === 1 ? 0 : experienceRanks[rank - 2];

    return {
      rank,
      prevThreshold,
      nextThreshold,
    };
  }

  const getXpPercentage = (currentXp, prevThreshold, nextThreshold) => {
    if (nextThreshold === null) return 100; // Max level
    const progress = currentXp - prevThreshold;
    const total = nextThreshold - prevThreshold;
    return Math.min(100, Math.max(0, (progress / total) * 100));
  };

  const { rank, prevThreshold, nextThreshold } = getRankInfo();
  const percentage = getXpPercentage(currentXp, prevThreshold, nextThreshold);

  useEffect(() => {
    chestSoundRef.current = new Audio(chestSound);
    dailySessionSoundRef.current = new Audio(dailySessionSound);
  }, []);

  const handleFirstTask = async (wallet) => {
    if (wallet) {
      const result2 = await axios
        .get(`https://api.worldofdypians.com/api/dappbay/task4/${wallet}`)
        .catch((e) => {
          console.error(e);
        });
      if (result2 && result2.status === 200) {
        console.log(result2);
      }
    }
  };

  // const fetchXpLeaderboards = async (token) => {
  //   await axios
  //     .post("https://apimini.worldofdypians.com/api/xp-leaderboards", {
  //       token: token,
  //     })
  //     .then((res) => {
  //       setXpLeaderboards({
  //         board1: res.data.previous.level2,
  //         board2: res.data.previous.level3,
  //         board3: res.data.previous.level4,
  //       });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const fetchAzure = async (token) => {
    await axios
      .get(
        "https://apimini.worldofdypians.com/api/weekly-xp/azure-crest-wallets"
      )
      .then((res) => {
        setXpLeaderboards((prev) => ({
          ...prev,
          board1: res.data.wallets,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchCrystal = async (token) => {
    await axios
      .get(
        "https://apimini.worldofdypians.com/api/weekly-xp/crystal-crown-wallets"
      )
      .then((res) => {
        setXpLeaderboards((prev) => ({
          ...prev,
          board2: res.data.wallets,
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const postToken = async (token, is_premium) => {
    setLoadingChest(true);
    let body = {
      data: token,
    };

    const initData = window.Telegram?.WebApp?.initDataUnsafe;
    if (initData?.start_param) {
      body = {
        data: token,
        referralCode: initData?.start_param,
        is_premium: is_premium,
      };
    }

    try {
      const res = await axios.post(
        `https://apimini.worldofdypians.com/api/tg_auth`,
        body
      );

      setUserData({
        tasks: res.data.userData.availableTasks,
        completedTasks: res.data.userData.completedTasks,
        totalPoints: res.data.userData.totalPoints,
        weeklyPoints: res.data.userData.weeklyPoints,
        streakPoints: res.data.userData.streakPoints,
        chestsPoints: res.data.userData.chestsPoints,
        tasksPoints: res.data.userData.tasksPoints,
        streakDay: res.data.userData.streakDay,
        lastStreakDate: res.data.userData.lastStreakDate,
        chestTimeStamp:
          new Date(res.data.userData.lastChestOpened).getTime() + 3600000,
        referredUsers: res.data.userData.referredUsers,
        referralCode: res.data.userData.referralCode,
        walletAddress: res.data.userData.walletAddress,
        referralPoints: res.data.userData.referralPoints,
      });
      setLoadingChest(false);
      setCurrentXp(res.data.userData.weeklyXP);
      setJwt(res.data.JWT);
      if (res.data.userData.walletAddress) {
        handleFirstTask(res.data.userData.walletAddress);
      }
    } catch (err) {
      setMaintenance(true);
      console.log(err);
    }
  };

  useEffect(() => {
    if (userData.chestTimeStamp) {
      const nextAvailableTime = userData.chestTimeStamp;
      const now = new Date();

      if (now.getTime() >= nextAvailableTime) {
        setCanClaimHourly(true);
      } else {
        setCanClaimHourly(false);
      }
    }
  }, [userData.chestTimeStamp]);

  const postWalletAddress = async (wallet) => {
    setError(validateInfo(wallet));
    if (validateInfo(wallet) === "") {
      setLoadingWallet(true);
      setTimeout(async () => {
        try {
          const res = await axios.post(
            `https://apimini.worldofdypians.com/api/link-wallet`,
            {
              token: jwt,
              walletAddress: wallet,
            }
          );
          setUserData((prevState) => ({
            ...prevState,
            walletAddress: res.data.walletAddress,
          }));
          setLoadingWallet(false);
          setConnectPopup(false);
          setChangeWalletPopup(false);
        } catch (err) {
          console.log(err);
        }
      }, 3000);
    }
  };

  const openHourlyChest = async () => {
    if (canClaimHourly) {
      try {
        const res = await axios.post(
          `https://apimini.worldofdypians.com/api/open-chest`,
          {
            token: jwt,
          }
        );
        setLoadingChest(false);
        chestSoundRef.current.play();
        setChestReward(res.data.pointsAwarded);
        setChestXp(res.data.xpAwarded);
        setCurrentXp(res?.data?.weeklyXP);
        setUserData((prevState) => ({
          ...prevState,
          totalPoints: res.data.totalPoints,
          weeklyPoints: res.data.weeklyPoints,
          chestsPoints: res.data.chestsPoints,
          chestTimeStamp: new Date(res.data.nextChestAvailableAt).getTime(),
        }));

        setCanClaimHourly(false);
      } catch (err) {
        console.log(err);
        setLoadingChest(false);
      }
    }
  };

  const fetchAllData = useCallback(() => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.ready();
      window.Telegram.WebApp.expand();
      window.Telegram.WebApp.setHeaderColor("bg_color", "#FF5733");
    }

    if (window.Telegram?.WebApp?.initDataUnsafe) {
      const user = window.Telegram.WebApp.initDataUnsafe.user;

      if (user) {
        postToken(window.Telegram.WebApp.initData, user.is_premium);
        setIsTelegram(true);
        if (user.username) {
          setUsername(user.username);
        } else if (user.first_name && user.last_name) {
          setUsername(user.last_name + user.last_name);
        } else if (user.first_name) {
          setUsername(user.last_name);
        } else if (user.last_name) {
          setUsername(user.first_name);
        } else {
          setUsername("User");
        }
      } else {
        setUsername("User");
        setIsTelegram(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchLeaderboard = async (token) => {
    try {
      const res = await axios.post(
        `https://apimini.worldofdypians.com/api/leaderboard`,
        {
          token: token,
        }
      );
      setLeaderboard({
        player: res.data.userPosition,
        users: res.data.topUsers,
        userCount: res.data.totalParticipants,
      });
    } catch (err) {
      console.log(err);
    }
  };
  const fetchWeeklyLeaderboard = async (token) => {
    try {
      const res = await axios.post(
        `https://apimini.worldofdypians.com/api/weekly-leaderboard`,
        {
          token: token,
        }
      );
      setWeeklyLeaderboard({
        player: res.data.currentLeaderboard.userPosition,
        prevPlayer: res.data.previousLeaderboard.userPosition,
        weeklyUsers: res.data.currentLeaderboard.topUsers,
        prevWeeklyUsers: res.data.previousLeaderboard.leaderboard,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const claimDailySession = async (token) => {
    setLoadingClaim(true);
    try {
      const res = await axios.post(
        `https://apimini.worldofdypians.com/api/claim-streak`,
        {
          token: token,
        }
      );
      setLoadingClaim(false);
      dailySessionSoundRef.current.play();

      setUserData((prevState) => ({
        ...prevState,
        totalPoints: res.data.totalPoints,
        weeklyPoints: res.data.weeklyPoints,
        streakDay: res.data.streakDay,
        streakPoints: res.data.streakPoints,
      }));
      setCurrentXp(res?.data?.weeklyXP);
      toast.success(`You have earned ${res?.data?.xpAwarded} XP!`, {
        className: "custom-toast-success",
        progressClassName: "custom-progress-success",
      });
      setCanClaim(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, [fetchAllData]);

  const canClaimToday = (lastStreakDate) => {
    setLoadingClaim(true);
    if (lastStreakDate === null) {
      setCanClaim(true);
    } else {
      const now = new Date();
      const lastDate = new Date(lastStreakDate);
      lastDate.setUTCHours(0, 0, 0, 0);
      now.setUTCHours(0, 0, 0, 0);

      if (now.getTime() > lastDate.getTime()) {
        setCanClaim(true);
      } else {
        setCanClaim(false);
      }
    }
    setLoadingClaim(false);
  };

  useEffect(() => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.ready(); // Ensure Telegram WebApp is ready
      window.Telegram.WebApp.expand();
      window.Telegram.WebApp.setHeaderColor("bg_color", "#FF5733");
    }
  }, []);

  useEffect(() => {
    canClaimToday(userData.lastStreakDate);
  }, [userData.lastStreakDate]);

  useEffect(() => {
    const hasVisited = sessionStorage.getItem("hasVisited");
    if (!hasVisited) {
      // Show the welcome screen if it's the user's first visit in this session
      setShowWelcome(true);
      sessionStorage.setItem("hasVisited", "true"); // Set the flag in sessionStorage
    }
  }, []);

  const handleClose = () => {
    setShowWelcome(false); // Hide the welcome screen when the user dismisses it
  };

  useEffect(() => {
    setTimeout(() => {
      setGeneralLoading(false);
    }, 1500);
  }, []);

  useEffect(() => {
    fetchLeaderboard(jwt);
    // fetchXpLeaderboards(jwt);
    fetchAzure(jwt);
    fetchCrystal(jwt);

    fetchWeeklyLeaderboard(jwt);
  }, [jwt]);

  const handleCompleteTask = async (taskId, secret) => {
    let body = {
      token: jwt,
      taskId: taskId,
    };

    if (secret) {
      body = {
        token: jwt,
        taskId: taskId,
        secretWord: secret,
      };
    }

    try {
      const res = await axios.post(
        `https://apimini.worldofdypians.com/api/complete-task`,
        body
      );
      setUserData((prevState) => ({
        ...prevState,
        totalPoints: res.data.totalPoints,
        weeklyPoints: res.data.weeklyPoints,
        tasks: res.data.availableTasks,
        completedTasks: res.data.completedTasks,
        tasksPoints: res.data.tasksPoints,
      }));
      setCurrentXp(res?.data?.weeklyXP);

      toast.success(`You have earned ${res?.data?.xpAwarded} XP!`, {
        className: "custom-toast-success",
        progressClassName: "custom-progress-success",
      });
    } catch (err) {
      toast.error("You have not completed the task!", {
        className: "custom-toast",
        progressClassName: "custom-progress",
      });
    }
  };

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const doesTaskExist = userData.tasks.some(
      (task) => task._id === "6723895e252255c10d636ec2"
    );
    if (doesTaskExist) {
      setHasTgTask(false);
    } else {
      setHasTgTask(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData.tasks]);

  useEffect(() => {
    const backButton = window.Telegram.WebApp.BackButton;

    const handleBack = () => {
      navigate(-1);
    };

    if (location.pathname !== "/") {
      backButton.show();
      backButton.onClick(handleBack);
    } else {
      backButton.hide();
      backButton.offClick(handleBack);
    }

    return () => {
      backButton.offClick(handleBack);
    };
  }, [location.pathname, navigate]);

  // if (!isTelegram) {
  //   return (
  //     <div
  //       className={`d-flex  justify-content-center align-items-center`}
  //       style={{ height: "100vh", width: "100vw" }}
  //     >
  //       <div className="d-flex flex-column align-items-center justify-content-center gap-2">
  //         <h1 className="use-telegram-title mb-0">Page available on</h1>
  //         <a
  //           href="https://t.me/WorldOfDypians_bot/wod"
  //           className="use-telegram-title"
  //         >
  //           Telegram
  //         </a>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div
      className={`container-fluid px-0 main-wrapper ${
        airdrop && "hide-scroll"
      }`}
    >
      {generalLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
            zIndex: 9999,
            position: "relative",
            background: "#3370E3",
          }}
        >
          <img src={getStartedWod} className="loading-wod" alt="" />
        </div>
      )}
      {maintenance ? (
        <UnderMaintenance />
      ) : (
        <>
          <GetStarted showWelcome={showWelcome} onClose={handleClose} />
          {!showWelcome && (
            <>
              <Routes>
                <Route
                  path="/"
                  element={
                    <Home
                      username={username}
                      referralPoints={userData.referralPoints}
                      tasks={userData.tasks}
                      userData={userData}
                      handleCompleteTask={handleCompleteTask}
                      walletAddress={userData.walletAddress}
                      postWalletAddress={postWalletAddress}
                      loadingWallet={loadingWallet}
                      setLoadingWallet={setLoadingWallet}
                      error={error}
                      connectPopup={connectPopup}
                      setConnectPopup={setConnectPopup}
                      dailySession={dailySession}
                      changeWalletPopup={changeWalletPopup}
                      setChangeWalletPopup={setChangeWalletPopup}
                    />
                  }
                />
                <Route
                  path="/leaderboard"
                  element={
                    <MainView
                      rank={rank}
                      nextThreshold={nextThreshold}
                      currentXp={currentXp}
                      percentage={percentage}
                    />
                  }
                />
                <Route
                  path="/leaderboard/ranks"
                  element={
                    <LeaderboardView
                      username={username}
                      leaderboard={leaderboard}
                      weeklyLeaderboard={weeklyLeaderboard}
                      totalPoints={userData.totalPoints}
                      weeklyPoints={userData.weeklyPoints}
                      hasTgTask={hasTgTask}
                    />
                  }
                />
                <Route
                  path="/leaderboard/airdrop"
                  element={
                    <AirdropView
                      username={username}
                      leaderboard={leaderboard}
                      weeklyLeaderboard={weeklyLeaderboard}
                      totalPoints={userData.totalPoints}
                      weeklyPoints={userData.weeklyPoints}
                      hasTgTask={hasTgTask}
                    />
                  }
                />
                <Route
                  path="/leaderboard/progress"
                  element={
                    <ProgressView rank={rank} xpleaderboards={xpleaderboards} />
                  }
                />
                <Route path="/leaderboard/rank" element={<RankView />} />

                <Route
                  path="/play"
                  element={
                    <Play
                      openHourlyChest={openHourlyChest}
                      chestTimeStamp={userData.chestTimeStamp}
                      canClaimHourly={canClaimHourly}
                      setCanClaimHourly={setCanClaimHourly}
                      loadingChest={loadingChest}
                      setLoadingChest={setLoadingChest}
                      chestReward={chestReward}
                      chestXp={chestXp}
                    />
                  }
                />
                <Route
                  path="/friends"
                  element={
                    <Friends
                      referredUsers={userData.referredUsers}
                      referralCode={userData.referralCode}
                    />
                  }
                />
                <Route
                  path="/earn"
                  element={
                    <Earn
                      tasks={userData.tasks}
                      completedTasks={userData.completedTasks}
                      wodTasks={userData.tasks.filter((item) => {
                        return (
                          item.partner === "world-of-dypians" &&
                          item.type !== "buy_wod" &&
                          item.type !== "open_chest"
                        );
                      })}
                      handleCompleteTask={handleCompleteTask}
                    />
                  }
                />
                <Route
                  path="/earn/:partnerId"
                  element={
                    <EarnPartner
                      tasks={userData.tasks}
                      completedTasks={userData.completedTasks}
                      handleCompleteTask={handleCompleteTask}
                    />
                  }
                />
                <Route
                  path="/earn/daily-opportunities"
                  element={
                    <DailyOpportunities
                      tasks={userData.tasks}
                      completedTasks={userData.completedTasks}
                      handleCompleteTask={handleCompleteTask}
                    />
                  }
                />
                <Route
                  path="/airdrop"
                  element={
                    <Airdrop
                    // userCount={leaderboard.userCount}
                    />
                  }
                />
              </Routes>
              <DailySession
                show={dailySession}
                onClose={() => setDailySession(false)}
                canClaimToday={canClaim}
                streakDay={userData?.streakDay}
                claimDailySession={() => claimDailySession(jwt)}
                loadingClaim={loadingClaim}
              />
              <ComingSoon show={airdrop} onClose={() => setAirdrop(false)} />
              <Navbar showAirdrop={() => setAirdrop(true)} />
              <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default App;
